export enum OptimizerScheduleType {
  Manual = 'manual',
  Optimized = 'optimized',
  Calculating = 'calculatng'
}
